const dateFormat = 'MM/DD/YYYY';
const dateFormatWithTime = 'MM/DD/YYYY hh:mm a';
const dateLabelFormat = 'MMM DD, YYYY';
const dateLabelFormatDay = 'MMMM Do';
const dateLabelFormatDayWithYear = 'MMM Do, YYYY';
const dateLabelFormatWithTime = 'MMM DD, YYYY hh:mm a';
const dateLabelFormatDayWithMonth = 'MMM D';

const STOCK_YARDS_BRAND_ID = '1018';
const HARRY_AND_DAVID_BRAND_ID = '1019';
const WOLFERMANS_BRAND_ID = '1020';
const PERSONALIZATION_BRAND_ID = '1030';
const MEDFORD_BRANDS = [
  STOCK_YARDS_BRAND_ID,
  HARRY_AND_DAVID_BRAND_ID,
  WOLFERMANS_BRAND_ID,
  PERSONALIZATION_BRAND_ID
];

const FEATURE_TYPES = {
  recognition: 'recognition',
  automation: 'automation'
};

const NOTIFICATION_STATUS = {
  initial: 'initial',
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning'
};

const NOTIFICATION_TYPE = {
  modal: 'modal',
  toast: 'toast'
};

const SIDEBAR_WIDTH = {
  closed: '80px',
  open: '224px'
};

const SIGN_UP_STEP = {
  createAccount: 'create-account',
  contactInfo: 'contact-info',
  companyInfo: 'company-info'
};

const SHARING_METHODS = {
  email: 'email',
  none: 'none',
  teamsApp: 'teams_app'
};

const FLOW_CODES = {
  standard: 'standard',
  simplified: 'simplified'
};

export {
  FEATURE_TYPES,
  FLOW_CODES,
  MEDFORD_BRANDS,
  NOTIFICATION_STATUS,
  NOTIFICATION_TYPE,
  SHARING_METHODS,
  SIDEBAR_WIDTH,
  SIGN_UP_STEP,
  dateFormat,
  dateFormatWithTime,
  dateLabelFormat,
  dateLabelFormatDay,
  dateLabelFormatDayWithMonth,
  dateLabelFormatDayWithYear,
  dateLabelFormatWithTime
};
